import React, { Component } from 'react';
import 'react-datetime/css/react-datetime.css';
import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import BasicSectionHeader from '../../components/views/BasicSectionHeader';

import DeleteContactModal from './modals/deleteContactModal';
import API from '../../utils/API';
import LoadingWizard from '../../components/spinner/wizard';
import TabsContainer from '../../components/views/TabsContainer';
import ViewsTable from '../../components/tables/ViewsTable';
import { withRouter } from 'react-router-dom';
import SectionHeader from '../../components/views/SectionHeader';
import SectionFooter from '../../components/views/SectionFooter';

const permissionOptions = [
	{ value: 'admin', label: 'Admin' },
	{ value: 'user', label: 'User' },
	{ value: 'guest', label: 'Guest' }
];

class ContactDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editing: false,
			contact: {},
			editedContact: {},
			invalid: false,
			saving: false,
			selectedSection: 0,
			deleteModalOpen: false,
			loading: true,
			requiredFields: {
				firstName: false,
				emailAddress: false
			}
		};
	}
	componentDidMount() {
		const contactId = this.props.match.params.contact;
		const { orgId } = this.props;
		API()
			.get(`Organizations/${orgId}/contacts/${contactId}`)
			.then((res) => {
				if (res.data) {
					this.setState({ contact: res.data, editedContact: { ...res.data }, loading: false });
				}
			})
			.catch((e) => {
				console.log(e);
				this.setState({ loading: false });
			});
	}

	saveBasics = async (editedContact, callback) => {
		const { orgId } = this.props;

		API()
			.patch(`Organizations/${orgId}/contacts/${editedContact._id}`, { request: 'update', ...editedContact })
			.then((res) => {
				if (res.data) {
					this.setState({ contact: { ...editedContact, ...res.data } });
					callback && callback();
				}
			});
	};

	saveDetails = (e) => {
		const { contact, editedContact, requiredFields } = this.state;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!editedContact[key] || editedContact[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});
		if (valid) {
			this.setState({ saving: true });
			this.saveBasics({ ...contact, ...editedContact }, () => {
				this.setState({ editing: false, saving: false, error: '', requiredFields: requiredFields });
			});
		} else {
			this.setState({ requiredFields: requiredFields });
		}
	};

	cancelEdit = () => {
		const contact = this.state.contact;

		const requiredFields = this.state.requiredFields;
		Object.keys(requiredFields).forEach((key) => {
			requiredFields[key] = false;
		});
		this.setState({
			editedContact: { ...contact },
			requiredFields: requiredFields,
			editing: false
		});
	};

	deleteContact = async () => {
		const { editedContact } = this.state;
		await API()
			.patch(`Organizations/${this.props.orgId}/contacts`, {
				request: 'delete',
				userIds: [editedContact._id]
			})
			.then((res) => {
				this.toggleDeleteModal();
				window.open('../', '_self');
			});
	};

	toggleDeleteModal = () => {
		this.setState({ deleteModalOpen: !this.state.deleteModalOpen });
	};

	updateSelected = (selectedIndex) => {
		this.setState({ selectedSection: selectedIndex });
	};
	renderSection() {
		const { selectedSection, contact, editedContact, events, requiredFields } = this.state;

		const { readOnly } = this.props;
		const perm = permissionOptions.find((p) => p.value === editedContact.permission);
		switch (selectedSection) {
			case 0:
				return (
					<div className="sectionBlock">
						<h2 className="blockHeader">Contact Details</h2>
						<InputField
							label="First Name"
							required={true}
							errorTrigger={requiredFields.firstName}
							value={editedContact.firstName}
							disabled={readOnly}
							onChange={(e) => {
								this.setState({
									editedContact: { ...editedContact, firstName: e.target.value },
									editing: true
								});
							}}
						/>
						<InputField
							label="Last Name"
							value={editedContact.lastName}
							disabled={readOnly}
							onChange={(e) => {
								this.setState({
									editedContact: { ...editedContact, lastName: e.target.value },
									editing: true
								});
							}}
						/>
						<InputField
							label="Email Address"
							required={true}
							errorTrigger={requiredFields.emailAddress}
							value={editedContact.emailAddress}
							type="email"
							disabled={readOnly}
							onChange={(e) => {
								this.setState({
									editedContact: { ...editedContact, emailAddress: e.target.value },
									editing: true
								});
							}}
						/>
						<SelectField
							label="Permission"
							value={perm}
							name="permission"
							options={permissionOptions}
							onChange={(permission) => {
								this.setState({
									editedContact: { ...editedContact, permission: permission.value },
									editing: true
								});
							}}
						/>
					</div>
				);
			case 1 /* 
				return (
					<EventPermissions
						events={events}
						editedMember={editedMember}
						editEventPermission={this.editEventPermission}
					/>
				); */:
				const columns = {
					eventName: 'Event Name',
					eventStartDate: 'Start Date',
					eventEndDate: 'End Date',
					firstName: 'First Name',
					lastName: 'Last Name',
					email: 'Email',
					updatedAt: 'Updated At',
					createdAt: 'Created At'
				};
				const columnTypes = {
					eventName: 'string',
					eventStartDate: 'date',
					eventEndDate: 'date',
					firstName: 'string',
					lastName: 'string',
					email: 'string',
					updatedAt: 'timestamp',
					createdAt: 'timestamp'
				};
				const toggledColumns = {};
				const normalizedColumns = Object.keys(columns).map((cfc) => {
					toggledColumns[cfc] = true;
					return {
						label: columns[cfc],
						key: cfc,
						value: cfc,
						type: columnTypes[cfc],
						sortAsc: false,
						sortDesc: false
					};
				});
				return (
					<ViewsTable
						style={{ margin: 0 }}
						columns={normalizedColumns}
						toggledColumns={toggledColumns}
						data={contact.attendeeRecords}
						mainColumnActive={false}
						readOnly={true}
						checked={[]}
					/>
				);
			default:
		}
	}

	render() {
		const {
			loading,
			contact,
			editing,
			editedContact,
			saving,
			requiredFields,
			deleteModalOpen,
			selectedSection
		} = this.state;
		return <div className='pageContainer'>
			{!loading && (
				<div className="sectionContainer">
					<SectionHeader
						title={`${contact.firstName} ${contact.lastName}`}
						titleIcon={
							contact.profilePicture ? (
								<img src={contact.profilePicture} style={{ maxWidth: '100%', overflow: 'clip' }} />
							) : (
								<div className="calibreBold fs-30">
									{contact.firstName && contact.firstName.toUpperCase().charAt(0)}
									{contact.lastName && contact.lastName.toUpperCase().charAt(0)}
								</div>
							)
						}
						breadcrumbs={[
							{
								name: 'Contacts',
							},
						]}
						subActions={[{ onClick: this.toggleDeleteModal, label: 'Delete Attendee' }]}
					>
						<TabsContainer
							tabs={[{ title: 'Information' }, { title: 'Events' }]}
							updateSelected={this.updateSelected}
							selectedIndex={selectedSection}
						/></SectionHeader>

					<div className="sectionBody ">{this.renderSection()}</div>
					<SectionFooter
						editing={editing}
						cancelEdit={this.cancelEdit}
						saveEdit={this.saveDetails}
						updatedAt={contact.updatedAt} />
					{deleteModalOpen && (
						<DeleteContactModal
							isOpen={deleteModalOpen}
							name={editedContact.firstName.concat(' ').concat(editedContact.lastName)}
							toggle={this.toggleDeleteModal}
							deleteContact={this.deleteContact}
						/>
					)}
				</div>)}
			<LoadingWizard text="LOADING CONTACT" loading={loading} />
		</div>
	}
}
export default withRouter(ContactDetails);
